module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/ISO 14001-2015.baac4ff6.png";